import React from 'react';
import AnchorLink from '../../../components/AnchorLink';
import styles from './index.scss';
const PromoLink = ({ children, link, promoClick }) => {
    if (!(link === null || link === void 0 ? void 0 : link.url)) {
        return React.createElement("div", { className: styles.tradingCellInnerContent }, children);
    }
    return (React.createElement(AnchorLink, { "data-testid": "promo-link", href: link === null || link === void 0 ? void 0 : link.url, newWindow: link === null || link === void 0 ? void 0 : link.newWindow, onClick: promoClick, className: styles.tradingCellInnerContent }, children));
};
export default PromoLink;
PromoLink.displayName = 'PromoLink';
//# sourceMappingURL=index.js.map